import React from "react";
import { cn } from "@/utils/cn";

interface PostContentSectionProps {
  viewMode?: "grid" | "list" | "feed";
  className?: string;
  children: React.ReactNode;
}

export const PostContentSection: React.FC<PostContentSectionProps> = ({
  viewMode = "grid",
  className,
  children,
}) => {
  if (viewMode === "list") {
    return (
      <div className={cn("flex items-center justify-between", className)}>
        {children}
      </div>
    );
  }

  if (viewMode === "feed") {
    return (
      <div className={cn("px-4 py-4 flex flex-col grow", className)}>
        {children}
      </div>
    );
  }

  return (
    <div className={cn("px-4 py-4 sm:p-6 flex flex-col grow", className)}>
      {children}
    </div>
  );
};
